<div>
  <div style="text-align: end;">
    <button class="close-button" (click)="close(null)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="mt-3 text-center">
    <span class="message-text">{{ message }}</span>
  </div>

  <div class="mt-3">
    <mat-dialog-actions align="end" class="modal-actions">
      <button mat-button (click)="close(false)">
        {{ "detail-tenant.no" | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="close(true)">
        {{ "detail-tenant.yes" | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
